import { render } from "./Chronik.vue?vue&type=template&id=01ba8477&scoped=true"
import script from "./Chronik.vue?vue&type=script&lang=js"
export * from "./Chronik.vue?vue&type=script&lang=js"

import "./Chronik.vue?vue&type=style&index=0&id=01ba8477&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-01ba8477"

export default script